module.exports = __webpack_public_path__ + "img/management.c1bc35bc.png";